<span appScanInput>
  <div *ngIf="isSpinnerLoad" class="spinner-container">
    <mat-spinner [diameter]="50"> </mat-spinner>
  </div>
  <app-layout></app-layout>
</span>
